import { safePrintWindow, escapeHtml } from '../../utils/printUtils';

export const LAB_INFO = {
  name: 'Bismi Lab & ECG',
  address: '3/114, East Pondy Road, Koliyanur, Villupuram',
  phone: '93633 24394',
};

export const rupee = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

const header = `<div class="hd"><div class="ln">${escapeHtml(LAB_INFO.name)}</div>
  <div class="ad">${escapeHtml(LAB_INFO.address)}</div><div class="ad"><b>Ph: ${LAB_INFO.phone}</b></div></div>`;

// Fluid width so the slip fills 3-inch (or any) paper, like the token slip
const baseStyles = `@page{margin:2mm}
  body{font-family:Arial,sans-serif;margin:0;padding:0 2px;width:auto;color:#000;line-height:1.3;font-size:15px}
  .hd{text-align:center;border-bottom:2px solid #000;padding-bottom:5px;margin-bottom:6px}
  .ln{font-size:22px;font-weight:900;letter-spacing:.5px}.ad{font-size:13px}
  table{width:100%;border-collapse:collapse;margin-top:6px}
  th,td{border:1.5px solid #000;padding:3px 4px;font-size:15px;text-align:left}
  th{background:#eee;font-weight:800}.r{text-align:right;white-space:nowrap}.b{font-weight:800}
  .meta{display:flex;justify-content:space-between;flex-wrap:wrap;gap:4px;font-size:15px;margin:3px 0}
  .foot{text-align:center;font-size:13px;margin-top:10px;border-top:2px dashed #000;padding-top:6px}`;

const fmtTime = (iso) => new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true });

export const printLabBill = (b) => {
  const rows = b.items.map((it, i) => `<tr><td>${i + 1}</td><td class="b">${escapeHtml(it.name)}</td><td class="r b">${rupee(it.rate)}</td></tr>`).join('');
  const status = b.balance > 0
    ? `<div style="text-align:center;font-size:16px;font-weight:900;margin-top:8px;border:2px solid #000;padding:4px">BALANCE DUE: ${rupee(b.balance)}</div>`
    : `<div style="text-align:center;font-size:16px;font-weight:900;margin-top:8px;border:2px solid #000;padding:4px">FULLY PAID</div>`;
  const body = `${header}
    <div class="meta"><span><b>Bill No:</b> ${escapeHtml(b.bill_no)}</span><span>${fmtTime(b.created_at)}</span></div>
    <div class="meta"><span><b>Name:</b> <span style="font-size:15px;font-weight:800">${escapeHtml(b.patient_name)}</span></span><span><b>${escapeHtml(b.age || '-')} / ${escapeHtml(b.sex || '-')}</b></span></div>
    ${b.referral_doctor ? `<div class="meta"><span><b>Ref. by:</b> ${escapeHtml(b.referral_doctor)}</span></div>` : ''}
    <table><tr><th style="width:30px">#</th><th>Test</th><th class="r" style="width:90px">Rate</th></tr>${rows}
      ${b.discount > 0 ? `<tr><td colspan="2" class="r">Gross</td><td class="r">${rupee(b.gross)}</td></tr><tr><td colspan="2" class="r">Discount</td><td class="r">- ${rupee(b.discount)}</td></tr>` : ''}
      <tr><td colspan="2" class="r b" style="font-size:15px">Final Amount</td><td class="r b" style="font-size:15px">${rupee(b.total)}</td></tr>
      <tr><td colspan="2" class="r">Advance / Paid</td><td class="r b">${rupee(b.paid)}</td></tr>
      <tr><td colspan="2" class="r">Balance</td><td class="r b">${rupee(b.balance)}</td></tr>
    </table>${status}
    <div class="foot">Thank you &bull; நன்றி</div>`;
  safePrintWindow(`Lab Bill ${b.bill_no}`, `<style>${baseStyles}</style>${body}`);
};

export const printLabSummary = (s, period = 'day', label = '') => {
  const title = { day: 'DAY', week: 'WEEKLY', month: 'MONTHLY' }[period] || 'DAY';
  const rows = s.tests.map((t) => `<tr><td>${escapeHtml(t.name)}</td><td class="r">${t.count}</td><td class="r">${rupee(t.amount)}</td></tr>`).join('');
  const line = (k, v, bold) => `<tr><td class="${bold ? 'b' : ''}">${k}</td><td class="r ${bold ? 'b' : ''}">${v}</td></tr>`;
  const body = `${header}
    <div style="text-align:center;font-size:16px;font-weight:900;margin:4px 0">${title} SUMMARY &mdash; ${escapeHtml(label || s.date)}</div>
    <table>${line('Bills', s.bill_count)}${line('Total Billed', rupee(s.billed), true)}${s.discount > 0 ? line('Discount Given', rupee(s.discount)) : ''}
      ${line('Cash Collected', rupee(s.cash))}${line('UPI Collected', rupee(s.upi))}
      ${s.old_dues_collected > 0 ? line('(incl. old dues collected)', rupee(s.old_dues_collected)) : ''}
      ${(s.from_nursing || []).filter((n) => n.count || n.cash || n.upi).map((n) => line(`${n.name} from nursing × ${n.count} (incl.)`, `${rupee(n.cash + n.upi)}`)).join('')}
      ${line('TOTAL COLLECTED', rupee(s.collected), true)}${line('Balance Due (bills in period)', rupee(s.balance_due), true)}</table>
    ${rows ? `<table><tr><th>Test</th><th class="r">Count</th><th class="r">Amount</th></tr>${rows}</table>` : ''}
    <div class="foot">Printed ${fmtTime(new Date().toISOString())}</div>`;
  safePrintWindow(`Lab Summary ${s.date}`, `<style>${baseStyles}</style>${body}`);
};
